import { render, staticRenderFns } from "./classifyManage.vue?vue&type=template&id=a3fe91c0&"
import script from "./classifyManage.vue?vue&type=script&lang=js&"
export * from "./classifyManage.vue?vue&type=script&lang=js&"
import style0 from "./classifyManage.vue?vue&type=style&index=0&id=a3fe91c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports